const ButtonLink = (props: any) => {
    return <div className="col-12 px-4">
        <div className="form-group mb-0">
            <button {...props} />
        </div>
    </div>
}

export default ButtonLink;